import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import batchImportExampleTw from '@/assets/img/batchImportExample-zhtw.png';
import batchImportExampleEn from '@/assets/img/batchImportExample-en.png';
import batchImportExampleCn from '@/assets/img/batchImportExample-cn.png';

/**
 * 呼叫資料匯入
 * @param {*} i18n
 */
export function callHelpDataProcessingImport(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.btn-confirm',
        popover: {
          title: i18n.$t('DataImport').demo,
          description: i18n.$t('DataImport').demoExplain,
        },
      },
      {
        element: '#importBtn',
        popover: {
          title: i18n.$t('DataImport').import,
          description: i18n.$t('DataImport').importExplain,
        },
      },
      {
        element: '#importStatusIcon',
        popover: {
          title: i18n.$t('DataImport').status_msg,
          description: i18n.$t('DataImport').statusMsgExplain,
        },
      },
      {
        element: '#refreshBtn',
        popover: {
          title: i18n.$t('Dashboard').refresh,
          description: i18n.$t('DataImport').refreshExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫異常原因管理範本介面
 * @param {*} i18n
 */
export function callHelpDataImportAbnormalReason(i18n) {
  const driverObj = driver();
  driverObj.highlight({
    element: '#exBtn_B_1_1',
    popover: {
      title: i18n.$t('DataImport').dataImportAbnormalReasonExample,
      description: `
      <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
      <p>NAME：${i18n.$t('DataImport').abnormalReasonNAME_Explain}</p>
      <p>DESCRIPTION：${i18n.$t('DataImport').abnormalReasonDESCRIPTION_Explain}</p>
      `,
      popoverClass: 'example',
    },
  });
}

/**
 * 呼叫缺陷管理範本介面
 * @param {*} i18n
 */
export function callHelpDataImportDefect(i18n) {
  const driverObj = driver();
  driverObj.highlight({
    element: '#exBtn_B_1_2',
    popover: {
      title: i18n.$t('DataImport').dataImportDefectExample,
      description: `
      <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
      <p>NAME：${i18n.$t('DataImport').defectNAME_Explain}</p>
      <p>DESCRIPTION：${i18n.$t('DataImport').defectDESCRIPTION_Explain}</p>
      <p>NUM_OF_DEFECT：${i18n.$t('DataImport').defectNUM_OF_DEFECT_Explain}</p>
      <p>CONTROL_ITEM_NAME：${i18n.$t('DataImport').defectCONTROL_ITEM_NAME_Explain}</p>
      <p>${i18n.$t('DataImport').defectCONTROL_ITEM_NAME_ExplainMore}</p>
      `,
      popoverClass: 'example',
    },
  });
}

/**
 * 呼叫檢驗判定管理範本介面
 * @param {*} i18n
 */
export function callHelpDataImportInspection(i18n) {
  const driverObj = driver();
  driverObj.highlight({
    element: '#exBtn_B_1_3',
    popover: {
      title: i18n.$t('DataImport').dataImportInspectionExample,
      description: `
      <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
      <p>NAME：${i18n.$t('DataImport').inspectionNAME_Explain}</p>
      <p>DESCRIPTION：${i18n.$t('DataImport').inspectionDESCRIPTION_Explain}</p>
      `,
      popoverClass: 'example',
    },
  });
}

/**
 * 呼叫管制圖規則範本介面
 * @param {*} i18n
 */
export function callHelpDataImportControlChartRules(i18n) {
  const driverObj = driver();
  driverObj.highlight({
    element: '#exBtn_B_2',
    popover: {
      title: i18n.$t('DataImport').dataImportControlChartRulesExample,
      description: `
      <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
      <p>NAME：${i18n.$t('DataImport').controlChartRulesNAME_Explain}</p>
      <p>ENABLE_RULE_1：${i18n.$t('DataImport').controlChartRulesENABLE_RULE_1_Explain}</p>
      <p>RULE_2_PARAME_1${i18n.$t('DataImport').controlChartRulesMin2Explain}</p>
      <p>RULE_3_PARAME_1${i18n.$t('DataImport').controlChartRulesMin2Explain}</p>
      <p>RULE_4_PARAME_1${i18n.$t('DataImport').controlChartRulesMin3Explain}</p>
      <p>${i18n.$t('DataImport').controlChartRulesM5Explain}</p>
      <p>${i18n.$t('DataImport').controlChartRulesM6Explain}</p>
      <p>RULE_7_PARAME_1${i18n.$t('DataImport').controlChartRulesMin1Explain}</p>
      <p>RULE_8_PARAME_1${i18n.$t('DataImport').controlChartRulesMin1Explain}</p>
      `,
      popoverClass: 'example',
    },
  });
}

/**
 * 呼叫使用者設定範本介面
 * @param {*} i18n
 */
export function callHelpDataImportUserSettings(i18n) {
  const driverObj = driver();
  driverObj.highlight({
    element: '#exBtn_C_2',
    popover: {
      title: i18n.$t('DataImport').dataImportUserSettingsExample,
      description: `
      <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
      <p>${i18n.$t('DataImport').dataImportUserSettingsExplain}</p>
      <p>EMP_CODE：${i18n.$t('DataImport').dataImportEMP_CODE_Explain}</p>
      `,
      popoverClass: 'example',
    },
  });
}

/**
 * 呼叫使用者匯入群組範本介面
 * @param {*} i18n
 */
export function callHelpDataImportUserGroup(i18n) {
  const driverObj = driver();
  driverObj.highlight({
    element: '#exBtn_user_group',
    popover: {
      title: i18n.$t('DataImport').dataImportUserGroupExample,
      description: `
      <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
      <p>${i18n.$t('DataImport').dataImportUserGroupExplain}</p>
      <p>EMP_CODE：${i18n.$t('DataImport').dataImportEMP_CODE_Explain}</p>
      <p>GROUP_NAME：${i18n.$t('DataImport').dataImportGROUP_NAME_Explain}</p>
      `,
      popoverClass: 'example',
    },
  });
}

/**
 * 呼叫參數範本介面
 * @param {*} i18n
 */
export function callHelpDataImportParameters(i18n) {
  const driverObj = driver();
  driverObj.highlight({
    element: '#exBtn_params',
    popover: {
      title: i18n.$t('DataImport').dataImportParametersExample,
      description: `
      <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
      <p>PARAMS_CODE：${i18n.$t('DataImport').dataImportParameters_PARAMS_CODE}</p>
      <p>PARAMS_NAME：${i18n.$t('DataImport').dataImportParameters_PARAMS_NAME}</p>
      `,
      popoverClass: 'example',
    },
  });
}

/**
 * 呼叫製程範本介面
 * @param {*} i18n
 */
export function callHelpDataImportGroup(i18n) {
  const driverObj = driver();
  driverObj.highlight({
    element: '#exBtn_group',
    popover: {
      title: i18n.$t('DataImport').dataImportParametersExample,
      description: `
      <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
      <p>GROUP_CODE：${i18n.$t('DataImport').dataImportGROUP_CODE}</p>
      <p>GROUP_NAME：${i18n.$t('DataImport').dataImportGROUP_NAME}</p>
      <p>PARAMS_CODE：${i18n.$t('DataImport').dataImportPARAMS_CODE}</p>
      <p>${i18n.$t('DataImport').dataImportGroupExplain}</p>
      `,
      popoverClass: 'example',
    },
  });
}

/**
 * 呼叫機台範本介面
 * @param {*} i18n
 */
export function callHelpDataImportMachine(i18n) {
  const driverObj = driver();
  driverObj.highlight({
    element: '#exBtn_machine',
    popover: {
      title: i18n.$t('DataImport').dataImportMachineExample,
      description: `
      <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
      <p>MACHINE_CODE：${i18n.$t('DataImport').dataImportMACHINE_CODE}</p>
      <p>MACHINE_NAME：${i18n.$t('DataImport').dataImportMACHINE_NAME}</p>
      <p>GROUP_CODE：${i18n.$t('DataImport').dataImportIncludeGROUP_CODE}</p>
      <p>PARAMS_CODE：${i18n.$t('DataImport').dataImportPARAMS_CODE}</p>
      <p>${i18n.$t('DataImport').dataImportMachineExplain}</p>
      `,
      popoverClass: 'example',
    },
  });
}

/**
 * 呼叫產品範本介面
 * @param {*} i18n
 */
export function callHelpDataImportProduct(i18n) {
  const driverObj = driver();
  driverObj.highlight({
    element: '#exBtn_model',
    popover: {
      title: i18n.$t('DataImport').dataImportMachineExample,
      description: `
      <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
      <p>PRODUCT_CODE：${i18n.$t('DataImport').dataImportPRODUCT_CODE}</p>
      <p>PRODUCT_NAME：${i18n.$t('DataImport').dataImportPRODUCT_NAME}</p>
      <p>MACHINE_CODE：${i18n.$t('DataImport').dataImportProductMACHINE_CODE}</p>
      <p>GROUP_CODE：${i18n.$t('DataImport').dataImportIncludeGROUP_CODE}</p>
      <p>PARAMS_CODE：${i18n.$t('DataImport').dataImportPARAMS_CODE}</p>
      <p>${i18n.$t('DataImport').dataImportProductExplain}</p>
      `,
      popoverClass: 'example',
    },
  });
}

/**
 * 管制項目匯入
 * @param {*} i18n
 */
export function callHelpControlItemImport(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#controlItem',
        popover: {
          title: i18n.$t('ControlItemImport').mainControlItem,
          description: i18n.$t('ControlItemImport').mainControlItemExplain,
        },
      },
      {
        element: '#subControlItem',
        popover: {
          title: i18n.$t('ControlItemImport').subControlItem,
          description: i18n.$t('ControlItemImport').subControlItemExplain,
        },
      },
      {
        element: '#templateDownload',
        popover: {
          title: i18n.$t('ControlItemImport').templateDownload,
          description: i18n.$t('ControlItemImport').templateDownloadExplain,
        },
      },
      {
        element: '#writeExample',
        popover: {
          title: i18n.$t('ControlItemImport').writeExample,
          description: i18n.$t('ControlItemImport').writeExampleExplain,
        },
      },
      {
        element: '#selectFile',
        popover: {
          title: i18n.$t('ControlItemImport').selectFile,
          description: i18n.$t('ControlItemImport').selectFileExplain,
        },
      },
      {
        element: '#uploadFile',
        popover: {
          title: i18n.$t('ControlItemImport').uploadFile,
          description: i18n.$t('ControlItemImport').uploadFileExplain,
        },
      },
      {
        element: '#filter',
        popover: {
          title: i18n.$t('Button').filter,
          description: i18n.$t('ControlItemImport').filterExplain,
        },
      },
      {
        element: '#refresh',
        popover: {
          title: i18n.$t('Label').refresh,
          description: i18n.$t('ControlItemImport').refreshExplain,
        },
      },
      {
        element: '#restart',
        popover: {
          title: i18n.$t('Label').restart,
          description: i18n.$t('ControlItemImport').restartExplain,
        },
      },
      {
        element: '#dataTable',
        popover: {
          title: i18n.$t('ControlItemImport').name,
          description: `
          <p>${i18n.$t('ControlItemImport').uploadFileExplainMore}</p>
          <p>${i18n.$t('ControlItemImport').uploadFileErrorExplain}</p>`,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫批次匯入範本
 * @param {*} i18n
 */
export function callHelpBatchImport(i18n, store) {
  let imgSource = null;
  switch (store.state.lang) {
    case 'zhtw':
      imgSource = batchImportExampleTw;
      break;

    case 'en':
      imgSource = batchImportExampleEn;
      break;

    case 'cn':
      imgSource = batchImportExampleCn;
      break;

    default:
      imgSource = batchImportExampleTw;
      break;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#controlItem',
        popover: {
          title: i18n.$t('ControlItemImport').batchImport,
          description: i18n.$t('ControlItemImport').batchImportExplain,
        },
      },
      {
        popover: {
          title: i18n.$t('ControlItemImport').batchImportTemplate,
          description: `<img src='${imgSource}'/>`,
          popoverClass: 'batchImportTemplate',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}
